import React from 'react';
import { Building2 } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import About from '../components/About';

const SCHEMA = {
  "@type": "Organization",
  "name": "Fernando Tech",
  "url": "https://fernandotech.com.br/quem-somos",
  "areaServed": "Ribeirão Preto e região",
  "description": "Empresa de tecnologia de Ribeirão Preto com mais de 15 anos de experiência em suporte de TI, assistência técnica, sistemas de gestão e segurança eletrônica.",
};

const FAQ = [
  { q: "Há quanto tempo a Fernando Tech atua?", a: "Temos mais de 15 anos de experiência em tecnologia, atendendo empresas e pessoas em Ribeirão Preto e região." },
  { q: "Quais serviços a Fernando Tech oferece?", a: "Suporte e terceirização de TI, assistência técnica, sistemas de gestão (Bling e SHOficina), câmeras Intelbras, criação de sites e hospedagem." },
  { q: "Vocês atendem só empresas?", a: "Não. Atendemos tanto empresas quanto pessoas físicas." },
  { q: "A Fernando Tech é revenda autorizada?", a: "Sim. Somos parceiros e revenda de marcas como Intelbras, Daten, Bling e SHOficina." },
  { q: "Onde a Fernando Tech fica?", a: "Estamos em Ribeirão Preto/SP e atendemos toda a região, além de suporte remoto para o Brasil." },
];

export default function QuemSomosPage() {
  return (
    <SubjectPageLayout
      path="/quem-somos"
      breadcrumbName="Quem Somos"
      breadcrumbIcon={<Building2 className="w-3.5 h-3.5" />}
      seoTitle="Quem Somos | Fernando Tech — Suporte de TI em Ribeirão Preto"
      seoDescription="Conheça a Fernando Tech: mais de 15 anos cuidando da tecnologia de empresas e pessoas em Ribeirão Preto e região, com suporte de TI, assistência técnica, sistemas de gestão e segurança eletrônica."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Nossa História',
        badgeIcon: <Building2 className="w-3.5 h-3.5" />,
        title: 'Quem Somos',
        accent: 'tecnologia de confiança há mais de 15 anos',
        subtitle: 'Somos uma empresa de Ribeirão Preto especializada em manter a tecnologia da sua empresa funcionando — com atendimento próximo, equipe especializada e soluções sob medida.',
      }}
      cta={{ heading: 'Vamos cuidar da sua tecnologia?', text: 'Converse com a equipe da Fernando Tech e descubra como podemos ajudar o seu negócio a crescer com tecnologia.' }}
    >
      <About />
    </SubjectPageLayout>
  );
}
